import ActionsForm from '@/shared/mixins/actionsForm'
import templateTable from './components/templateTable/templateTable.vue'
import templateFilter from '../TemplateFilter/templateFilter.vue'
import tabsTemplate from '../detailsTemplate/tabsTemplate/tabsTemplate.vue'
import panelTemplate from '../detailsTemplate/panelTemplate/panelTemplate.vue'

// import Tools from '@/components/tools/Tools.js'

export default {
  name: 'templateQmaPIT',
  components: {templateTable, templateFilter, tabsTemplate, panelTemplate},
  mixins: [ActionsForm],
  data () {
    return {
      details: false,
      TipoQmaTemplate: 'PIT',
      templateid: null,
      tipoTemplate: null

    }
  },
  methods: {
    search (data) {
      this.$refs.tablepit.formSearch = data
      this.$refs.tablepit.onLoad()
    },
    recarregarTemplateEdicao () {
    },
    atualizaPainel () {
      this.$refs.painel.onLoad()
    },
    templateQMADetalhes (value) {
      this.details = true
      this.tipoTemplate = value.tipoTemplate
      this.templateid = value.id
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/templateQmaPIT/templateQmaPIT.js